import { useQuery } from '@tanstack/react-query';
import { axiosInstance } from '@config/axios/axios.config';
import { paths } from '@common/types';

type ConsentListResponse =
  paths['/program/{program_id}/{patient_id}/consent']['get']['responses']['200']['content']['application/json'];

interface IProgramConsentProps {
  patient_id: string;
  program_id: string;
}

const programConsentRequest = async ({
  program_id,
  patient_id,
}: IProgramConsentProps) => {
  const response = await axiosInstance.get<ConsentListResponse>(
    `/program/${program_id}/${patient_id}/consent`,
  );

  return response.data;
};

export const useProgramConsentQuery = (props: IProgramConsentProps) => {
  const query = useQuery({
    queryKey: ['programConsent', props.patient_id, props.program_id],
    enabled: !!props.patient_id && !!props.program_id,
    queryFn: () => programConsentRequest(props),
  });

  return query;
};
